module.exports = window["popupMaker"]["useQueryParams"];